import { Controller } from "@hotwired/stimulus"

// Both code panels remain visible without JavaScript. Selection is kept in the
// DOM so Turbo can restore the same tab without a separate saved preference.
export default class extends Controller {
  static targets = ["tablist", "tab", "panel"]

  connect() {
    this.tabs = this.tabTargets.filter(tab => this.panelFor(tab))
    if (!this.hasTablistTarget || this.tabs.length === 0) return

    this.tablistTarget.setAttribute("role", "tablist")
    this.tablistTarget.setAttribute("aria-orientation", "horizontal")
    this.tabs.forEach(tab => {
      const panel = this.panelFor(tab)
      tab.id ||= `${panel.id}-tab`
      tab.setAttribute("role", "tab")
      tab.setAttribute("aria-controls", panel.id)
      panel.setAttribute("role", "tabpanel")
      panel.setAttribute("aria-labelledby", tab.id)
      panel.tabIndex = 0
    })

    const initial = this.tabs.find(tab => tab.getAttribute("aria-selected") === "true")
      || this.tabs.find(tab => tab.dataset.panel === "html")
      || this.tabs[0]
    this.activate(initial)
    this.tablistTarget.hidden = false
  }

  select(event) {
    if (!this.tabs.includes(event.currentTarget)) return
    this.activate(event.currentTarget)
  }

  keydown(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return
    const index = this.tabs.indexOf(event.currentTarget)
    if (index === -1) return

    let next
    switch (event.key) {
      case "ArrowRight": next = (index + 1) % this.tabs.length; break
      case "ArrowLeft": next = (index - 1 + this.tabs.length) % this.tabs.length; break
      case "Home": next = 0; break
      case "End": next = this.tabs.length - 1; break
      default: return
    }
    event.preventDefault()
    this.activate(this.tabs[next], true)
  }

  activate(selected, focus = false) {
    this.tabs.forEach(tab => {
      const active = tab === selected
      tab.setAttribute("aria-selected", String(active))
      tab.tabIndex = active ? 0 : -1
      this.panelFor(tab).hidden = !active
    })
    if (focus) selected.focus()
  }

  panelFor(tab) {
    return this.panelTargets.find(panel => panel.dataset.panel === tab.dataset.panel)
  }
}
